









































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import BankCard from '@/components/BankCard.vue';
import AlpacaBtn from '@/components/AlpacaBtn.vue';
import { totalRewards, totalValueStaked } from '@/utils/bank';
import BigNumber from 'bignumber.js';
import { validateAccount } from '@/utils/web3';
import { totalValue } from '@/contract/soloBank';

@Component({
  components: {
    BankCard,
    AlpacaBtn
  },
})
export default class Bank extends Vue {
  public totalRewards = new BigNumber(0);
  public totalValueStaked = new BigNumber(0);
  public allBankInfo = [];
  public pids = [7, 6, 4, 3, 2, 1, 0];

  get account() {
    return this.$store.getters.getAccount;
  }

  public async mounted() {
    // this.totalRewards = await totalRewards();
    // this.totalValueStaked = await totalValueStaked();
    // bankInfoAll(this.account);
    this.getTotalValue()
  }

  public async getTotalValue() {
    const res = await totalValue();
    if (res) {
      this.totalRewards = new BigNumber(res.totalRewardsValue);
      this.totalValueStaked = new BigNumber(res.totalDepositValue);
    }
  }

  public async connectWallet() {
    await validateAccount(this);
  }

  @Watch('account', {immediate: true})
  public async onAccount(val: string) {
    if (val) {
    }
  }
}
